import { Button, Card, Col, DatePicker, Form, Input, Row, Select } from "antd";
import React, { useState } from "react";
import { FaDollarSign } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";

import PageHeading from "../../../components/common/PageHeading";

const Comparables = () => {
  const initialList = [{ id: uuidv4() }];

  const [accounts, setAccounts] = useState(initialList);

  function handleAddAccount() {
    const newList = accounts.concat({ id: uuidv4() });
    setAccounts(newList);
  }

  function handleRemoveAccount(id) {
    const newList = accounts.filter((item) => item.id !== id);
    setAccounts(newList);
  }

  return (
    <div>
      <PageHeading heading="New Comparable Property for test1" />
      <Card title="Comparable Property Name and Address" bordered={false}>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
          colon={false}
        >
          <Form.Item
            label="Comparable Property Name"
            name="ComparablePropertyName"
            required
          >
            <Input style={{ width: "50%" }} />
          </Form.Item>

          <Form.Item label="Address" name="Address" required>
            <Input placeholder="Address 1" />
          </Form.Item>
          <Form.Item label=" ">
            <Input placeholder="Address 2" />
          </Form.Item>
          <Form.Item label=" ">
            <Row gutter={16}>
              <Col span={10}>
                <Input placeholder="City" />
              </Col>
              <Col span={7}>
                <Select
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "AA",
                    },
                    {
                      value: "AE",
                    },
                    {
                      value: "AK",
                    },
                    {
                      value: "AL",
                    },
                  ]}
                />
              </Col>
              <Col span={7}>
                <Input placeholder="Zip" />
              </Col>
            </Row>
          </Form.Item>
          <Form.Item label="Phone Number" name="PhoneNumber">
            <Input />
          </Form.Item>
          <Form.Item label="Website" name="Website">
            <Input />
          </Form.Item>
          <Form.Item
            label="Year Built"
            name="Year Built
      "
          >
            <Input />
          </Form.Item>
          <Form.Item label="Amenities" name="Amenities">
            <Input />
          </Form.Item>
        </Form>

        <b>Comparable Unit Types</b>

        <ul>
          <Row style={{ marginBottom: 12 }}>
            <Col className="tableHead" span={2}>
              <p>Beds</p>
            </Col>
            <Col className="tableHead" span={3}>
              <p>Bathrooms</p>
            </Col>
            <Col className="tableHead" span={4}>
              <p>Square Feet</p>
            </Col>
            <Col className="tableHead" span={5}>
              <p>Rent</p>
            </Col>
            <Col className="tableHead" span={5}>
              <p>Date</p>
            </Col>
            <Col className="tableHead" span={4}>
              <p>Similar To</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          {accounts.map((item) => (
            <li key={item.id}>
              <Form.Item label="">
                <Row>
                  <Col span={2}>
                    <Select
                      showSearch
                      allowClear
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        {
                          value: "0",
                        },
                        {
                          value: "1",
                        },
                        {
                          value: "2",
                        },
                        {
                          value: "3",
                        },
                        {
                          value: "4",
                        },
                      ]}
                    />
                  </Col>
                  <Col span={3}>
                    <Select
                      showSearch
                      allowClear
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        {
                          value: "0",
                        },
                        {
                          value: "0.5",
                        },
                        {
                          value: "1",
                        },
                        {
                          value: "1.5",
                        },
                        {
                          value: "2",
                        },
                      ]}
                    />
                  </Col>
                  <Col span={4}>
                    <Input />
                  </Col>
                  <Col span={5}>
                    <Input
                      addonBefore={<FaDollarSign size={12} />}
                      defaultValue={(Math.round(0 * 100) / 100).toFixed(2)}
                    />
                  </Col>
                  <Col span={5}>
                    <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
                  </Col>
                  <Col span={4}>
                    <Select
                      showSearch
                      allowClear
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[]}
                    />
                  </Col>
                  <Col span={1}>
                    {accounts.length > 1 ? (
                      <Button
                        className="roundSmallButton"
                        onClick={() => {
                          handleRemoveAccount(item.id);
                        }}
                        type="primary"
                        shape="circle"
                        icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                        size={"small"}
                      />
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </Form.Item>
            </li>
          ))}

          <Form.Item label="">
            <Button
              className="addPropertyGroupButton"
              type="primary"
              onClick={handleAddAccount}
              size={"small"}
              icon={<i className="fa-solid fa-circle-plus"></i>}
            >
              {" "}
              Add Another Line
            </Button>
          </Form.Item>
        </ul>
      </Card>

      <br />
        <Row gutter={16}>
          <Col>
            <Button  type="primary">Save</Button>
          </Col>
          <Col>
            <Button>Save & Add Another</Button>
          </Col>
          <Col>
            <Button>Cancel</Button>
          </Col>
        </Row>
    </div>
  );
};

export default Comparables;
